import { useEffect } from 'react'
import { StringParam, useQueryParam } from 'use-query-params'

import { getResponses } from '../../api/responses'
import useApiCall from '../../api/useApiCall'
import { IResponse, useResponsesStore } from '../../stores/responsesStore'
import LoadingSection from '../LoadingSection/LoadingSection'

import ResponseSection from './ResponseSection/ResponseSection'
import ResponsesHead from './ResponsesHead/ResponsesHead'
import ResponsesNav from './ResponsesNav/ResponsesNav'

import styles from './responses.module.scss'

function Responses() {
    const [searchParam] = useQueryParam('search', StringParam)

    const [
        { newResponseId },
        { setResponses, setResponseContent, setCurrentResponseId },
    ] = useResponsesStore()

    const [{ loading }] = useApiCall(
        getResponses,
        handleGetResponses,
        searchParam || ''
    )

    function handleGetResponses(responses: IResponse[]) {
        setResponses(responses)
        const [defaultResponse] = responses
        setCurrentResponseId(defaultResponse.name)
    }

    useEffect(() => {
        newResponseId && setResponseContent([])
    }, [newResponseId, setResponseContent])

    return (
        <main className={styles.responses}>
            <ResponsesHead />
            <ResponsesNav />
            {loading ? <LoadingSection /> : <ResponseSection />}
        </main>
    )
}

export default Responses
